import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar, User, ArrowLeft } from "lucide-react";

export default function NewsDetail() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/news/${slug}`).then((r) => setArticle(r.data)).catch(() => setArticle(null)).finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="max-w-3xl mx-auto px-4 py-24">Loading…</div>;
    if (!article) return (
        <div className="max-w-3xl mx-auto px-4 py-24 text-center">
            <div className="font-display text-3xl mb-4">Article not found</div>
            <Link to="/news" className="text-primary font-semibold">← Back to news</Link>
        </div>
    );

    return (
        <article className="max-w-3xl mx-auto px-4 md:px-8 py-12" data-testid="news-detail">
            <Link to="/news" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-6">
                <ArrowLeft className="w-4 h-4" /> Back to news
            </Link>
            <div className="overline text-primary mb-3">{article.category}</div>
            <h1 className="font-display text-4xl md:text-5xl font-bold leading-tight mb-4">{article.title}</h1>
            <div className="flex gap-4 text-sm text-muted-foreground mb-8">
                <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" />{new Date(article.created_at).toLocaleDateString()}</span>
                <span className="inline-flex items-center gap-1.5"><User className="w-3.5 h-3.5" />{article.author}</span>
            </div>
            {article.image_url && (
                <div className="aspect-[16/9] overflow-hidden mb-8">
                    <img src={article.image_url} alt={article.title} className="w-full h-full object-cover" />
                </div>
            )}
            <div className="prose max-w-none">
                {article.body.split("\n\n").map((para, i) => (
                    <p key={i} className="text-lg leading-relaxed text-ink mb-6">{para}</p>
                ))}
            </div>
        </article>
    );
}
